import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Accounting'*/ 'src/controllers/Accounting/Accounting'),
	loading: Loading,
});
